import { listen, type UnlistenFn } from '@tauri-apps/api/event';

import {
  RPA_RECORDER_PROTOCOL,
  type SessionId,
} from '@/features/rpa/recorder/api/recorder-bridge';
import type {
  RecorderAnalysisStatusChangedPayload,
  RecorderUploadStateChangedPayload,
  UploadStage,
} from '@/tauri/rpa-recorder/upload-types';
import { isTauri } from '@/tauri/utils';

export const RECORDING_NAMED_EVENT = 'record:recording-named';
export const RECORDING_UPLOAD_STATE_CHANGED_EVENT =
  RPA_RECORDER_PROTOCOL.events.uploadStateChanged;
export const RECORDING_ANALYSIS_STATUS_CHANGED_EVENT =
  RPA_RECORDER_PROTOCOL.events.analysisStatusChanged;

export interface RecordingNamedPayload {
  readonly sessionId: SessionId;
  readonly name: string;
}

export type {
  RecorderUploadStateChangedPayload as RecordingUploadStateChangedPayload,
  UploadStage,
};

export async function listenRecordingNamed(
  handler: (payload: RecordingNamedPayload) => void
): Promise<UnlistenFn> {
  if (!isTauri()) return () => undefined;
  return listen<RecordingNamedPayload>(RECORDING_NAMED_EVENT, (event) => {
    handler(event.payload);
  });
}

export async function listenRecordingUploadState(
  handler: (payload: RecorderUploadStateChangedPayload) => void
): Promise<UnlistenFn> {
  if (!isTauri()) return () => undefined;
  return listen<RecorderUploadStateChangedPayload>(
    RECORDING_UPLOAD_STATE_CHANGED_EVENT,
    (event) => {
      handler(event.payload);
    }
  );
}

export async function listenRecordingAnalysisStatus(
  handler: (payload: RecorderAnalysisStatusChangedPayload) => void
): Promise<UnlistenFn> {
  if (!isTauri()) return () => undefined;
  return listen<RecorderAnalysisStatusChangedPayload>(
    RECORDING_ANALYSIS_STATUS_CHANGED_EVENT,
    (event) => {
      handler(event.payload);
    }
  );
}
